import { useScopedAppFlagStore } from '@frontend/scope';
import { useAiSettingsAccess } from './use-has-ai-settings-access';

export const useAiReceptionistAccess = () => {
  const { getCustomizationFlagValue } = useScopedAppFlagStore();
  const { hasAiSettingsAccess } = useAiSettingsAccess();

  const hasTlAiVoiceAccess = getCustomizationFlagValue('truelarkaivoice');
  const hasTlAiMessagingAccess =
    getCustomizationFlagValue('truelarkaimessaging') || getCustomizationFlagValue('aimessaging');

  const hasAiReceptionistAccess = (hasTlAiVoiceAccess || hasTlAiMessagingAccess) && hasAiSettingsAccess;

  return {
    hasTlAiVoiceAccess,
    hasTlAiMessagingAccess,
    hasAiReceptionistAccess,
  };
};
